import { render, staticRenderFns } from "./another_relationship.vue?vue&type=template&id=c3b2b89e&"
import script from "./another_relationship.vue?vue&type=script&lang=js&"
export * from "./another_relationship.vue?vue&type=script&lang=js&"
import style0 from "./another_relationship.vue?vue&type=style&index=0&id=c3b2b89e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports